import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { images, routes, whyPoints } from '../data/site';
import { ReviewsCallout } from './ReviewsCallout';
import { SiteLink } from './SiteLink';
export function WhyPegasus() {
  return <section aria-labelledby="why-heading" className="w-full border-y border-ink/10 bg-white" data-id="element-261" data-mp="1sj6gw5nxbo3m">
      <div className="mx-auto max-w-container px-5 py-12 sm:px-8 lg:py-16" data-id="element-262" data-mp="1nqddbl46ylt4">
        <div className="grid grid-cols-1 items-start gap-10 lg:grid-cols-12 lg:gap-12" data-id="element-263" data-mp="21ia2pheh6hlt">
          <div className="lg:col-span-6" data-id="element-264" data-mp="1wjysv6o6k73l">
            <p className="text-[14px] font-bold uppercase text-pine" data-id="element-265" data-mp="1wix98dt3mca9">Why Pegasus</p>
            <h2 id="why-heading" className="mt-2 text-h2-mobile font-semibold text-ink lg:text-h2-desktop" data-id="element-266" data-mp="2bfxymanthv5k">
              Local Experience That Stays With You
            </h2>
            <p className="mt-4 text-body text-ink/80 sm:text-body-lg" data-id="element-267" data-mp="h3hwnm22136i">
              Pegasus Spas has been part of Brooklyn and Michigan's Irish Hills since 1977. We know
              these products, we know Michigan backyards, and we believe the relationship should
              continue long after the sale.
            </p>
            <p className="mt-3 text-body text-ink/80 sm:text-body-lg" data-id="element-268" data-mp="3ugkxia23yq3m">
              Our team helps customers compare options, plan for ownership and find support when
              questions or service needs come up. That practical, local guidance is the difference.
            </p>

            <ul className="mt-6 grid grid-cols-1 gap-x-8 gap-y-2 sm:grid-cols-2" data-id="element-269" data-mp="d264agozkttp">
              {whyPoints.map(point => <li key={point} className="flex items-start gap-2" data-id="element-270" data-mp="m346qujs0ta6">
                  <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-pine" aria-hidden="true" data-id="element-271" data-mp="m3x4x74o6agp" />
                  <span className="text-[16px] leading-6 text-ink" data-id="element-272" data-mp="r1ozya0m2cp4">{point}</span>
                </li>)}
            </ul>

            <div className="mt-7 flex flex-wrap items-center gap-4" data-id="element-273" data-mp="2stll8bckz0x3">
              <SiteLink to={routes.about} className="inline-flex min-h-[48px] items-center rounded-btn bg-pegasus-magenta px-6 text-[16px] font-bold text-white transition-colors duration-150 ease-out hover:bg-[#bb2f83]" data-id="element-274" data-mp="2sttw5xp57w5n">
                Why Choose Pegasus
              </SiteLink>
              <SiteLink to={routes.location} className="inline-flex min-h-[44px] items-center gap-1.5 text-[16px] font-medium text-pegasus-blue underline decoration-pegasus-blue/40 underline-offset-4 transition-colors duration-150 ease-out hover:text-pegasus-magenta hover:decoration-pegasus-magenta" data-id="element-275" data-mp="40oqylsubcaa">
                Visit the Showroom
                <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-276" data-mp="rs3w0mc047p8" />
              </SiteLink>
            </div>
          </div>

          <div className="lg:col-span-6" data-id="element-277" data-mp="11nxh4u3sd9im">
            <div className="aspect-[3/2] w-full overflow-hidden rounded-card" data-id="element-278" data-mp="11oyrewcz9rza">
              <img src={images.whyPegasus} alt="Interior of a small-town spa showroom with hot tubs on display and shelves of spa care supplies" className="h-full w-full object-cover" loading="lazy" decoding="async" data-id="element-279" data-mp="wqf52uuh2e6e" />
            </div>
          </div>
        </div>

        <ReviewsCallout data-id="element-280" data-mp="1bc2pmh4l7kps" />
      </div>
    </section>;
}